import {SmartComponent} from "smart-component-js";

class MasonryComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        super(element, parentComponent, params);

        this.init();
    }

    init() {
        window.addEventListener('load', () => {
            this.resizeMasonryItem();
        });

        window.addEventListener('resize', () => {
            this.resizeMasonryItem();
        });
    }

    resizeMasonryItem() {
        const grid = this.element;
        const cards = this.element.querySelectorAll(':scope > *');
        const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-gap'));

        cards.forEach(card => {
            const contentHeight = card.getBoundingClientRect().height;

            const rowSpan = Math.ceil((contentHeight + rowGap) / (rowHeight + rowGap));

            card.style.gridRowEnd = `span ${rowSpan}`;
        });

        this.element.classList.add('loaded');

    }
}

export default MasonryComponent;